import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		setNewsletterOption: ['newsletterOption'],
	},
	{
		prefix: 'newsletter-option/'
	}
)

const initialState = {
	newsletter: true
}

const setNewsletterOption = (state = initialState, {newsletterOption}) => ({
	...state,
	newsletter: newsletterOption
})

export default createReducer(initialState, {
	[Types.SET_NEWSLETTER_OPTION]: setNewsletterOption
})